import * as React from 'react';
import * as style from './style.css';
import { Tabs } from './Tabs';
import { LinksList } from './LinksList';
import { getDefaultTab } from './utils/getDefaultTab';
import { IQuickLinksTab } from '../../containers/QuickLinksContainer/types';
import { UIHeading1 } from '@cian/ui-kit';
import clsx from 'clsx';
import { useIsDesktop } from '../../hooks/common';

interface IQuickLinksTabsComponentProps {
  tabs: IQuickLinksTab[];
}

export const QuickLinksTabsComponent = ({ tabs }: IQuickLinksTabsComponentProps) => {
  const [selectedTab, setSelectedTab] = React.useState(getDefaultTab(tabs));
  const [isExpanded, setIsExpanded] = React.useState(false);
  const isDesktop = useIsDesktop();

  const onTabChange = React.useCallback((_: React.ChangeEvent<HTMLInputElement>, value: number) => {
    setSelectedTab(value);
  }, []);
  const onMoreButtonClick = React.useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  const links = React.useMemo(() => tabs[selectedTab].links, [tabs, selectedTab]);

  return (
    <div className={clsx(style['container'], !isDesktop && style['container-mobile'])} data-testid="QuickLinks">
      <UIHeading1>Выберите фильтры</UIHeading1>
      {isExpanded && <Tabs tabs={tabs} value={selectedTab} onChange={onTabChange} />}
      <LinksList links={links} isExpanded={isExpanded} onMoreButtonClick={onMoreButtonClick} />
    </div>
  );
};
